import React, { FC } from "react";
import { CircularProgress as MuiCircularProgress } from "@mui/material";

type Props = React.ComponentProps<typeof MuiCircularProgress>;

const CircularProgress: FC<Props> = (props) => {
    return <MuiCircularProgress {...props}/>
}

export default CircularProgress;